
        <div [ngStyle]="contentStyle$ | async">
            <siq-video-player #videoPlayer (completed)="completed.emit()"></siq-video-player>
            <siq-image-player #imagePlayer (completed)="completed.emit()"></siq-image-player>
        </div>
        <ng-container *ngIf="htmlCode$ | async as htmlCode">
            <iframe [srcdoc]="htmlCode"></iframe>
        </ng-container>
    